import React from 'react';
import Switch from '@mui/material/Switch';

const SensorConfigTable = ({
  mod,
  struttura,
  ListaStrutture,
  setStruttura,
  piano,
  ListaPiani,
  setPiano,
  getlistaPiani,
  tipoStanza,
  TipoStanza,
  setTipoStanza,
  stanza,
  setStanza,
  rebootDevice,
  mac,
  serial,
  sensore,
  logging,
  setLogging
}) => {
  return (
    <div className="table-container" style={{ width: '20%' }}>
      <table className="scheda" style={{ width: '100%' }}>
        <tbody>
          <tr>
            <td>ID Sensore</td>
            <td style={{ userSelect: 'text' }}>{sensore.deviceInfo.deviceId}</td>
          </tr>
          <tr>
            <td>Seriale Sensore</td>
            <td style={{ userSelect: 'text' }}>{serial}</td>
          </tr>
          <tr>
            <td>MAC</td>
            <td style={{ userSelect: 'text' }}>{mac}</td>
          </tr>

          {/* Struttura */}
          <tr>
            <td>Struttura</td>
            <td>
              <select
                value={struttura}
                disabled={mod === 0}
                onChange={(e) => setStruttura(e.target.value, 'struttura')}
              >
                <option value="undefined">Nessuno</option>
                {ListaStrutture.map((s, i) => (
                  <option key={i} value={s.name}>{s.name}</option>
                ))}
              </select>
            </td>
          </tr>

          {/* Piano */}
          <tr>
            <td>Piano</td>
            <td>
              <select
                value={piano ?? 'nessuno'}
                disabled={mod === 0}
                onChange={async (e) => {
                  setPiano(e.target.value);
                  await getlistaPiani();
                }}
              >
                <option value="undefined">Nessuno</option>
                {ListaPiani.map((p, i) => (
                  <option key={i} value={p.id}>{p.id}</option>
                ))}
              </select>
            </td>
          </tr>

          {/* Stanza */}
          {<tr>
            <td>Stanza</td>
            <td>
              <input
                type="text"
                value={stanza}
                disabled={mod === 0}
                onChange={(e) => setStanza(e.target.value, 'stanza')}
              />
            </td>
          </tr>}

          {/* Tipo Stanza */}
          <tr>
            <td>Tipo Stanza</td>
            <td>
              <select
                value={tipoStanza ?? ''}
                disabled={mod === 0}
                onChange={(e) => setTipoStanza(e.target.value)}
              >
                {TipoStanza.map((t, i) => (
                  <option key={i} value={t.value}>{t.id}</option>
                ))}
              </select>
            </td>
          </tr>

          {/* Logging */}
          <tr>
            <td>Log</td>
            <td>
              <Switch
                disabled={mod === 0}
                checked={!!logging}
                onClick={() => setLogging(!logging)}
              />
            </td>
          </tr>

          <tr><td>Riavvia</td><td><button onClick={rebootDevice}>Reboot</button></td></tr>

        </tbody>
      </table>
    </div>
  );
};

export default SensorConfigTable;
